import { SubscriptionSchemeId } from 'common/enums';
import { subscriptionSchemeInfo } from 'config/constants';
import { GIGABYTE, hasStoragePlan } from 'helpers/storage';
import { sizeLabel } from 'pages/vault-new/plan-format';

// How the two plan kinds are sold in the UI (matches the vault wizard).
const KIND_LABEL: Record<StoragePlanKind, string> = {
  long_term: 'One-time',
  temporary: 'Annual',
};

// "100 GB · Annual". Legacy vaults (no storage plan) fall back to the old
// subscription tier name.
export const planName = (vault: VaultType) => {
  if (hasStoragePlan(vault)) {
    const kind = vault.storageKind ? ` · ${KIND_LABEL[vault.storageKind]}` : '';
    return `${sizeLabel(Math.round(vault.storageLimit / GIGABYTE))}${kind}`;
  }
  return vault.subscriptionType
    ? (subscriptionSchemeInfo[vault.subscriptionType as SubscriptionSchemeId]
        ?.name ?? 'Legacy')
    : 'Legacy';
};
